import { useEffect, useState } from "react"
import { Card, Button, Modal, CloseButton, Spinner, Row, Col, Form } from 'react-bootstrap';
import DataGrid from '../../controls/DataGrid.js/DataGrid'
import { useSelector } from 'react-redux';
import Icon from "../../controls/Icons/Icon";
import DynamicDropdownSearchable from "../../controls/DynamicDropdownSearchable";
import MasterdataForm from "./Masterdataform";
import { dateDisplayFormater } from "../../../Utils";

const Masterdata = () => {
    const state = useSelector(state => state);
    const [refreshGrid, setRefreshGrid] = useState(false);
    const [showGrid, setshowGrid] = useState(false);
    const [loading, setLoading] = useState(false);
    const [masterdatatype, setmasterdatatype] = useState(1);
    const [masterdatadesc, setmasterdatadesc] = useState("Describe the Client"); //useState("Describe the Client");
    const [inputValueDropdown, setinputValueDropdown] = useState({
        MasterTypeId: 1
    });
    const [inputValue, setInputValue] = useState({
    });
    const columns = [
        {
            field: "Text",
            title: "Description",
            sortName: "Text",
            sortable: true,
            size: 800,

        },
        {
            field: "CreatedDate",
            title: "Created Date",
            sortable: true,
            formatter: dateDisplayFormater,
        },
        {
            field: "UpdatedDate",
            title: "Last Updated Date",
            sortable: true,
            formatter: dateDisplayFormater,
        },

        {
            dataField: "remove",
            title: "",
            text: "Delete",
            formatter: (cellContent, row) => {
                return (<div>
                    {state.access.edit ? <Button
                        className="btn-xs me-2 mb-2 p-0" variant="link"
                        onClick={() => handleEdit(row)}
                    ><Icon name="BsPencilFill" className='fs-5' /></Button> : ""}

                    {state.access.delete ? <Button variant="link"
                        className="btn-xs mb-2 p-0"
                        onClick={() => handleDelete(row)}
                    >
                        <Icon name="BsTrash" className='fs-5' />
                    </Button> : ""}
                </div>
                );
            },
        }
    ];

    useEffect(() => {
        if (masterdatatype == 0) {
            setshowGrid(false);
        } else {
            setshowGrid(true);
        }

    }, []);



    const handleEdit = (res) => {
        setInputValue(res)
        setShowModal(true)
    };

    const handleDelete = ((res) => {
        window.confirm("Do you want to delete?", function () {
            setLoading(true);
            fetch(state.projectdetail.API + "/MasterData/delete?Id=" + res.Id, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
            }).then(response => response.json()).then((res) => {
                if (res.Succeeded) {
                    window.alert("Deleted successfuly");
                    setRefreshGrid(!refreshGrid);
                }
                else {
                    window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
                }
            }).catch((err) => {
                window.alert(state.projectdetail.ErrorMessage);
            }).finally(() => {
                setLoading(false);
            });
        })

    });

    const options = {
        dataType: "server",
        showExport: true,
        showRefresh: true,
        sortName: "Text",
        sortOrder: "asc",
    };
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => setShowModal(false);
    const handleAfter = (res) => {
        if (res.Succeeded) {
            window.alert("MasterData saved successfully");
            handleClose();
            setRefreshGrid(!refreshGrid);
        }
        else {
            window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
        }
    };

    const handleDropdownChange = (e) => {

        let value = e.target.value;
        if (value > 0) {
            setmasterdatatype(value);
            setinputValueDropdown(c => ({ ...c, ["MasterTypeId"]: value }));
            setmasterdatadesc(e.target.options[e.target.selectedIndex].text);
            setLoading(true);
            setshowGrid(true)
            setRefreshGrid(!refreshGrid);
            setLoading(false);

        } else {
            setshowGrid(false);
            setinputValueDropdown(c => ({ ...c, ["MasterTypeId"]: value }));
            setLoading(false);
             setmasterdatadesc("");
            window.alert('Please select the Master Data Type', function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            return false;
        }

    }

    return (
        <>
            <Row className="mb-2">
                <Col md={12}>
                    <h4 className='form-heading mb-12'>
                        {masterdatadesc}
                        <div className='d-inline-block float-end'>
                            <Form.Group>
                                <Form.Label>Master Data Type<code className='required-symbol'>*</code></Form.Label>
                                <DynamicDropdownSearchable from={state.projectdetail.API + "/MasterDataType/GetAll"} label="Type" value="Id" fetchType="get" name="Id" onDropdownChange={handleDropdownChange} defaultval={inputValueDropdown.MasterTypeId} />
                            </Form.Group>
                        </div>
                    </h4>
                </Col>
            </Row>

            <Card>
                {showGrid &&

                    <Card.Body>
                        {loading ? <div className="text-center"><Spinner as="span" animation="border" size="lg" role="status" aria-hidden="true" /> </div> : ""}
                        < DataGrid url={state.projectdetail.API + "/masterdata/MasterDataGrid?type=" + masterdatatype} classes="table table-striped" options={options} columns={columns} refresh={refreshGrid} />

                    </Card.Body>
                }
            </Card>
            <Modal show={showModal} onHide={handleClose} size="2g" backdrop="static" keyboard={false}>
                <Modal.Header>
                    <h4>{inputValue.Id ? "Edit " : "Add "} Master Data </h4>
                    <CloseButton onClick={handleClose} className="btn-close" />
                </Modal.Header>
                <Modal.Body>
                    <MasterdataForm afterSave={handleAfter} _inputValue={inputValue} onCancel={handleClose} />
                </Modal.Body>
            </Modal>
        </>
    );
}
export default Masterdata;
